<template>
  <ls-table-layout>
    <div slot="btn">
      <a-space>
        <a-button type="primary" @click="handleExport">导出</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <a-table
          ref="dataTable"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1000, y: 'calc(100vh - 180px)' }"
          :columns="columns"
          :data-source="tableDataSource"
          :pagination="false"
        >
          <template slot="formDate" slot-scope="text">
            {{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}
          </template>
        </a-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { apiSearchRealCompletedDetail } from '@/api/report/estate-daily-plan-analysis-report.js'
import moment from 'moment'

export default {
  // eslint-disable-next-line
  name: "analysisReportDetail",
  components: {},
  data () {
    return {
      // 表格字段
      columns: [
        {
          title: '工单号',
          dataIndex: 'wipEntityNumber',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '计划单号',
          dataIndex: 'orderNo',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '组织',
          dataIndex: 'organizationCode',
          align: 'center',
          width: 80,
          ellipsis: true
        },
        {
          title: '供应商编码',
          dataIndex: 'supplierCode',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          align: 'center',
          width: 160,
          ellipsis: true
        },
        {
          title: '单价',
          dataIndex: 'unitPrice',
          align: 'center',
          width: 160,
          ellipsis: true
        },
        {
          title: '计划数量',
          dataIndex: 'planCompletedQty',
          align: 'center',
          width: 80,
          ellipsis: true
        },
        {
          title: '完成数量',
          dataIndex: 'realCompletedQty',
          align: 'center',
          width: 80,
          ellipsis: true
        },
        {
          title: '计划开始时间',
          dataIndex: 'scheduledStartDate',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '计划完成时间',
          dataIndex: 'scheduledCompletionDate',
          align: 'center',
          width: 100,
          ellipsis: true
          // scopedSlots: { customRender: 'formDate' }
        },
        {
          title: '开工时间',
          dataIndex: 'startDate',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '完工时间',
          dataIndex: 'completionDate',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '交货时间',
          dataIndex: 'deliveryDate',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '数据收集时间',
          dataIndex: 'collectDate',
          align: 'center',
          width: 100,
          ellipsis: true
        }
      ],
      tableDataSource: []
    }
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    // 导出
    handleExport () {
      this.$message.warning('下载中')
      // const params = this.$refs.dataTable.searchParams
      // this.$refs.download.openModal(params)
      this.download('/inv/invDailyPlanAnalysis/exportRealCompletedDetail', { id: this.$route.params.id }, `产业园每日计划分析报表明细_${moment().format('YYYY-MM-DD')}.xlsx`)
    },
    // 表单搜索
    onSearch () {
      if (!this.$route?.params?.id) { return false }
      apiSearchRealCompletedDetail({ id: this.$route.params.id }).then((res) => {
        if (res?.code === 200) {
          this.tableDataSource = res.data
        }
      })
    }
  }
}
</script>

<style scoped lang="less"></style>
